import { render, staticRenderFns } from "./Itemized.vue?vue&type=template&id=72839fe2&scoped=true&"
import script from "./Itemized.vue?vue&type=script&lang=js&"
export * from "./Itemized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72839fe2",
  null
  
)

export default component.exports